import { render, staticRenderFns } from "./HCaptcha.vue?vue&type=template&id=3d2f9e52&"
import script from "./HCaptcha.vue?vue&type=script&lang=js&"
export * from "./HCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports